import PptxGenJS from "pptxgenjs";
import {
  BRAND_WATERMARK,
  PAGE_TITLE_TEXT,
  PRIVATE_AND_CONFIDENTIAL_TEXT,
  SPLIT_PANEL_LEFT,
} from "./components";

export const SPLIT_LEFT_MASTER = "SPLIT_LEFT_MASTER";

export const splitLeftMasterSlide: PptxGenJS.SlideMasterProps = {
  title: SPLIT_LEFT_MASTER,
  background: {
    color: "#FFFFFF",
  },
  objects: [
    PAGE_TITLE_TEXT,
    SPLIT_PANEL_LEFT,
    PRIVATE_AND_CONFIDENTIAL_TEXT,
    BRAND_WATERMARK,
  ],
  slideNumber: {
    x: "50%",
    y: "95%",
    fontSize: 8,
    color: "#000000",
  },
};
